import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { CandidateCountersActions } from './counters/candidate-counters.store';
import { FullCandidateActions } from './full-candidate/full-candidate.store';

@Injectable({ providedIn: 'root' })
export class CandidateAutoUpdateEffects {
  private counters$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FullCandidateActions.viewSuccess),
      map(() => CandidateCountersActions.fetch()),
    ),
  );

  constructor(private actions$: Actions) {}
}
